<section>
  <div class="container">
    <div class="row mt-2 border Page-Header">
      <h6 class="HeadContent">
        <span class="p-2"
          >Admin - Course Master Management - {{ courseMasterMode }} Course
          Master</span
        >
      </h6>
    </div>

    <form [formGroup]="addEditExamCourseMaster" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <!-- AGency Status -->
            <div class="col-md-2">
              <div class="d-flex my-2 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Location Name</div>
              </div>
            </div>
            <div class="col-md-4 my-2">
              <select
                formControlName="Location_Id"
                class="form-control form-control-sm inputfield-txt"
                [ngClass]="getError('Location_Id') ? 'red-border-required' : ''"
              >
                <option hidden>Choose Location Name</option>
                <option
                  class="border-bottom"
                  *ngFor="let code of locationCode"
                  [value]="code.Code"
                >
                  {{ code.Description }}
                </option>
              </select>
            </div>
          </div>

          <!--  Website -->
          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Examination Agency</div>
              </div>
            </div>
            <div class="col-md-10 my-1">
              <div>
                <input
                  formControlName="Exam_Agency_Name"
                  type="text"
                  [ngClass]="
                    getError('Exam_Agency_Name') ? 'red-border-required' : ''
                  "
                  class="form-control form-control-sm input-txt"
                />
              </div>
            </div>
          </div>

          <!-- Secondary Phone Number -->

          <!-- Address -->

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Course Name</div>
              </div>
            </div>
            <div class="col-md-6 my-1">
              <div>
                <input
                  formControlName="Course_Name"
                  type="text"
                  class="form-control form-control-sm input-txt"
                  placeholder=""
                  [ngClass]="
                    getError('Course_Name') ? 'red-border-required' : ''
                  "
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Exam Short Name</div>
              </div>
            </div>
            <div class="col-md-6 my-1">
              <div>
                <input
                  formControlName="Exam_Short_Name"
                  type="text"
                  class="form-control form-control-sm input-txt"
                  [ngClass]="
                    getError('Exam_Short_Name') ? 'red-border-required' : ''
                  "
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Course Category Type</div>
              </div>
            </div>
            <div class="col-md-4 my-1">
              <select
                formControlName="Course_Category_Type_Code"
                class="form-control form-control-sm inputfield-txt"
                [ngClass]="
                  getError('Course_Category_Type_Code')
                    ? 'red-border-required'
                    : ''
                "
              >
                <option hidden>Choose Category Course Type</option>
                <option
                  class="border-bottom"
                  *ngFor="let code of courseCategoryType"
                  [value]="code.Code"
                >
                  {{ code.Description }}
                </option>
              </select>
            </div>

            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <!-- <div class="p-0 label-red">*</div> -->
                <div class="p-0">Exam Duration (in Minutes)</div>
              </div>
            </div>
            <div class="col-md-4 my-1">
              <div>
                <input
                  appClearSelection
                  formControlName="Exam_Duration"
                  type="number"
                  class="form-control form-control-sm input-txt"
                  onKeyPress="if(this.value.length==10) return false;"
                  (keypress)="preventEnteringString($event, 4)"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Exam Level</div>
              </div>
            </div>
            <div class="col-md-4 my-1">
              <select
                formControlName="Exam_Level_Type_Code"
                class="form-control form-control-sm inputfield-txt"
                [ngClass]="
                  getError('Exam_Level_Type_Code') ? 'red-border-required' : ''
                "
              >
                <option hidden>Choose Exam Level</option>
                <option
                  class="border-bottom"
                  *ngFor="let code of examLevelType"
                  [value]="code.Code"
                >
                  {{ code.Description }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <!-- <div class="p-0 label-red">*</div> -->
                <div class="p-0">Number Of Questions</div>
              </div>
            </div>
            <div class="col-md-4 my-1">
              <div>
                <input
                  formControlName="Number_Of_Question"
                  type="number"
                  onKeyPress="if(this.value.length==10) return false;"
                  class="form-control form-control-sm input-txt"
                  (keypress)="preventEnteringString($event, 4)"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Overall Exam Difficulty Level</div>
              </div>
            </div>
            <div class="col-md-4 my-1">
              <select
                formControlName="Exam_Difficulty_Level_Type_Code"
                class="form-control form-control-sm inputfield-txt"
                [ngClass]="
                  getError('Exam_Difficulty_Level_Type_Code')
                    ? 'red-border-required'
                    : ''
                "
              >
                <option hidden>Choose Exam Difficulty Level</option>
                <option
                  class="border-bottom"
                  *ngFor="let code of examDifficultLevelType"
                  [value]="code.Code"
                >
                  {{ code.Description }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red"></div>
                <div class="p-0">Total Test Score</div>
              </div>
            </div>
            <div class="col-md-4 my-1">
              <div>
                <input
                  formControlName="Total_Test_Score"
                  type="number"
                  onKeyPress="if(this.value.length==10) return false;"
                  class="form-control form-control-sm input-txt"
                  (keypress)="preventEnteringString($event, 4)"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0">Description</div>
                <div class="p-0 label-red"></div>
              </div>
            </div>
            <div class="col-md-10 my-1">
              <div class="border p-2 rounded d-flex justify-content-between align-items-center">
                <div class="course-description" [innerHTML]="truncatedDescription"></div>
                <div class="d-flex gap-2">
                <button *ngIf="addEditExamCourseMaster.get('Course_Description')?.value"  type="button" class="btn btn-sm btn-light text-secondary d-flex align-items-center gap-1"
                        (click)="openDescritionEditor()">
                  <i class="fa fa-pencil"></i> Edit
                </button>
                <button *ngIf="!addEditExamCourseMaster.get('Course_Description')?.value"  type="button" class="btn btn-sm btn-light text-secondary d-flex align-items-center gap-1"
                        (click)="openDescritionEditor()">
                  <i class="fa fa-plus"></i> Add
                </button>
                      <!-- Preview button -->
                <button
                  *ngIf="addEditExamCourseMaster.get('Course_Description')?.value"
                  type="button"
                  class="btn btn-sm btn-light text-secondary d-flex align-items-center gap-1"
                  (click)="previewTextDisplayFLag = true"
                >
                  <i class="fa fa-eye"></i> Preview
                </button>
                </div>

              </div>
            </div>


          </div>
          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0"></div>
                <div class="p-0 label-red"></div>
              </div>
            </div>
            <div class="col-md-6">
              <!-- <button class="btn btn-sm bg-light border" [disabled]="!addEditExamCourseMaster.get('Course_Description')?.value" type="button">
                <span (click)="previewTextDisplayFLag = true"
                  >PREVIEW COURSE MASTER DESCRIPTION</span
                >
              </button> -->
            </div>
            <div class="col-md-4 d-flex justify-content-end">
              <div
                class=" d-flex justify-content-center"
                *ngIf="courseMasterMode !== 'View'"
              >
                <span>
                  <button
                    class="btn btn-sm bl-btn btn-theme-primary"
                    [disabled]="addEditExamCourseMaster.invalid"
                  >
                    <span class="text-light">SAVE</span>
                  </button>
                </span>
                <span class="mx-2">
                  <button
                    type="button"
                    class="btn btn-sm bg-light border"
                    (click)="clear()"
                  >
                    CANCEL
                  </button>
                </span>
              </div>
              <div
                class="mb-2 my-3 d-flex justify-content-center"
                *ngIf="courseMasterMode === 'View'"
              >
                <span>
                  <button class="btn btn-sm bl-btn" [disabled]="true">
                    <span class="text-light">SAVE</span>
                  </button>
                </span>
                <span class="mx-2">
                  <button
                    type="button"
                    class="btn btn-sm bg-light border"
                    [disabled]="true"
                  >
                    CANCEL
                  </button>
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12"></div>
          </div>

          <!-- <div class="row mt-4">
            <div class="col-md-12">
              <div
                class="mb-2 my-3 d-flex justify-content-center"
                *ngIf="courseMasterMode !== 'View'"
              >
                <span>
                  <button
                    class="btn btn-sm bl-btn"
                    [disabled]="addEditExamCourseMaster.invalid"
                  >
                    <span class="text-light">SAVE1</span>
                  </button>
                </span>
                <span class="mx-2">
                  <button
                    type="button"
                    class="btn btn-sm bg-light border"
                    (click)="clear()"
                  >
                    CANCEL
                  </button>
                </span>
              </div>
              <div
                class="mb-2 my-3 d-flex justify-content-center"
                *ngIf="courseMasterMode === 'View'"
              >
                <span>
                  <button class="btn btn-sm bl-btn" [disabled]="true">
                    <span class="text-light">SAVE1</span>
                  </button>
                </span>
                <span class="mx-2">
                  <button
                    type="button"
                    class="btn btn-sm bg-light border"
                    [disabled]="true"
                  >
                    CANCEL
                  </button>
                </span>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </form>
  </div>
</section>

<section>
  <app-preview-text
    [previewDialogDisplayFlag]="previewTextDisplayFLag"
    [previewText]="addEditExamCourseMaster.value.Course_Description"
    (displayOff)="displayDialogOff()"
  ></app-preview-text>
</section>

<section *ngIf="examAgencyRequestParam.courseMasterId" class="mt-4 px-4">
  <div class="row border Page-Header" >
      <div class="col-md-12">
        <h6 class="HeadContent d-flex align-items-center">
          <span>Course- {{ courseMaster.Course_Name }} </span>
          <span title="Add Course" (click)="addCourse()">
            <i class="fa fa-plus-circle plus-icon ms-3 fs-2 pointer-cursor"></i>
          </span>

        </h6>
      </div>
    <div class="col-md-12 scroll-style" *ngIf="courseList.length; else nocontent">
      <table class="table table-bordered table-hover table-responsive sticky-header">
        <thead>
          <tr class="table-active border-none">
            <th scope="col" class="clone-action-col">
              <div class="d-flex justify-content-center">
                <b class="text-center">Clone</b>
              </div>
            </th>
            <th scope="col" style="width: 12em" sortable="Exam_Short_Name" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center">Short Name</b>
                <i *ngIf="sortColumn === 'Exam_Short_Name'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" style="width: 25em" sortable="Course_Name" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Course Name </b>
                <i *ngIf="sortColumn === 'Course_Name'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" style="width: 15em" sortable="Exam_Year" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Year - Month </b>
                <i *ngIf="sortColumn === 'Exam_Year'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" style="width: 12em" sortable="Course_Delivery_Type_Name" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Delivery Type </b>
                <i *ngIf="sortColumn === 'Course_Delivery_Type_Name'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" style="width: 12em" sortable="Exam_Level_Type_Name" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Exam Level </b>
                <i *ngIf="sortColumn === 'Exam_Level_Type_Name'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" style="width: 10em" sortable="Exam_Difficulty_Level_Type_Name" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Difficulty Level </b>
                <i *ngIf="sortColumn === 'Exam_Difficulty_Level_Type_Name'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" style="width: 10em" sortable="Notification_Date" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Notification Date </b>
                <i *ngIf="sortColumn === 'Notification_Date'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" style="width: 10em" sortable="Location_Name" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Location Region </b>
                <i *ngIf="sortColumn === 'Location_Name'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" style="width: 10em" sortable="Notification_Url" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Notification URL </b>
                <i *ngIf="sortColumn === 'Notification_Url'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" style="width: 12em" sortable="Application_Due_Date" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Application Due Date </b>
                <i *ngIf="sortColumn === 'Application_Due_Date'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" style="width: 10em">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Exam Date </b>

              </div>
            </th>
            <th scope="col" class="compact-metric-col" sortable="Exam_Duration" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Duration </b>
                <i *ngIf="sortColumn === 'Exam_Duration'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" class="compact-metric-col" sortable="Number_Of_Question" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> # of Questions </b>
                <i *ngIf="sortColumn === 'Number_Of_Question'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>
            <th scope="col" class="compact-metric-col" sortable="Total_Test_Score" (sort)="onSort($event)">
              <div class="d-flex justify-content-center">
                <b class="text-center"> Total Score </b>
                <i *ngIf="sortColumn === 'Total_Test_Score'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
              </div>
            </th>


        </thead>
        <tbody>
          <tr
            *ngFor="let courseMaster of courseList; let i = index"
            (click)="
            selectCourse(courseMaster);
            editCourse(courseMaster.Course_Id)"
            [class.bg-selected-row]="courseMaster.Course_Id === selectedCourse"
          >
            <td class="clone-action-col">
              <div class="d-flex justify-content-center">
                <button
                  type="button"
                  class="btn btn-link p-0 clone-course-btn"
                  title="Clone this Course"
                  aria-label="Clone this Course"
                  (click)="$event.stopPropagation(); cloneCourse(courseMaster, $event)"
                >
                  <i class="fa fa-clone"></i>
                </button>
              </div>
            </td>
            <td>
              <div>
                {{
                  courseMaster.Exam_Short_Name
                }}
              </div>
            </td>
            <td>
              <div>
                {{ courseMaster.Course_Name }}
              </div>
            </td>
            <td>
              <div>
                {{ formatYearMonth(courseMaster.Exam_Year, courseMaster.Exam_Month) }}
              </div>
            </td>

            <td>
              <div>
                {{ courseMaster.Course_Delivery_Type_Name }}
              </div>
            </td>
            <td>
              <div>
                {{ courseMaster.Exam_Level_Type_Name }}
              </div>
            </td>
            <td>
              <div>
                {{ courseMaster.Exam_Difficulty_Level_Type_Name }}
              </div>
            </td>
            <td>
              <div>
                {{ courseMaster.Notification_Date | date }}
              </div>
            </td>
            <td>
              <div>
                {{ courseMaster.Location_Name }}
              </div>
            </td>
            <td>
              <div>
                {{ courseMaster.Notification_Url }}
              </div>
            </td>
            <td>
              <div>
                {{ courseMaster.Application_Due_Date | date }}
              </div>
            </td>
            <td>
              <div>
                {{ courseMaster.Actual_Exam_Date | date }}
              </div>
            </td>
            <td>
              <div [ngClass]="['d-flex', getAlignment(courseMaster.Exam_Duration)]">
                {{ courseMaster.Exam_Duration }}
              </div>
            </td>
            <td>
              <div [ngClass]="['d-flex', getAlignment(courseMaster.Number_Of_Question)]">
                {{ courseMaster.Number_Of_Question }}
              </div>
            </td>
            <td>
              <div [ngClass]="['d-flex', getAlignment(courseMaster.Total_Test_Score)]">
                {{ courseMaster.Total_Test_Score }}
              </div>
            </td>

          </tr>
        </tbody>
      </table>

    </div>

  </div>
      <ng-template #nocontent>
      <div class="d-flex justify-content-center mt-2 bg-white">
        No Content
      </div>
    </ng-template>


</section>
